import { AllGames } from "./Games"

/**all games datas
 * id and type are required
 * type define the other properties, see Games.ts
 */
export const AllGamesData: AllGames = [
  {
    id: "labo.p02.g01",
    type: "fill",
    draggables: [{ id: "movable01" }, { id: "movable02" }, { id: "movable03" }],
    links: [
      [
        { type: "drop", id: "drop01", key: "", want: ["movable01"], have: "" },
        { type: "text", key: "def01" },
      ],
      [
        { type: "drop", id: "drop02", key: "", want: ["movable02"], have: "" },
        { type: "text", key: "def02" },
      ],
      [
        { type: "drop", id: "drop03", key: "", want: ["movable03"], have: "" },
        { type: "text", key: "def03" },
      ],
    ],
  },
  {
    id: "labo.p03.g01",
    type: "dnd",
    draggables: [
      {
        id: "movable01",
      },
      {
        id: "movable04",
      },
      {
        id: "movable07",
      },
    ],
    droppables: [
      {
        id: "drop1",
        want: ["movable01"],
        have: "",
        cat: "cat01",
      },
      {
        id: "drop2",
        want: ["movable04"],
        have: "",
        cat: "cat02",
      },
      {
        id: "drop3",
        want: ["movable07"],
        have: "",
        cat: "cat03",
      },
    ],
  },
  {
    id: "engin.p02.g01",
    type: "sort",
    direction: "vertical",
    sortables: [
      "movable01",
      "movable02",
      "movable03",
      "movable04",
      "movable05",
      "movable06",
    ],
  },
  {
    id: "engin.p03.g01",
    type: "sort",
    direction: "vertical",
    sortables: [
      "movable01",
      "movable02",
      "movable03",
      "movable04",
      "movable05",
    ],
  },
  {
    id: "engin.p04.g01",
    type: "dnd",
    draggables: [
      {
        id: "movable01",
      },
      {
        id: "movable02",
      },
      {
        id: "movable03",
      },
      {
        id: "movable04",
      },
      {
        id: "movable05",
      },
      {
        id: "movable06",
      },
      {
        id: "movable07",
      },
    ],
    droppables: [
      {
        id: "drop01",
        cat: "cat01",
        have: "",
        want: ["movable01", "movable02", "movable03", "movable04", "movable05"],
      },
      {
        id: "drop02",
        cat: "cat01",
        have: "",
        want: ["movable01", "movable02", "movable03", "movable04", "movable05"],
      },
      {
        id: "drop03",
        cat: "cat01",
        have: "",
        want: ["movable01", "movable02", "movable03", "movable04", "movable05"],
      },
      {
        id: "drop04",
        cat: "cat01",
        have: "",
        want: ["movable01", "movable02", "movable03", "movable04", "movable05"],
      },
      {
        id: "drop05",
        cat: "cat01",
        have: "",
        want: ["movable01", "movable02", "movable03", "movable04", "movable05"],
      },
      {
        id: "drop06",
        cat: "cat02",
        have: "",
        want: ["movable06", "movable07"],
      },
      {
        id: "drop07",
        cat: "cat02",
        have: "",
        want: ["movable06", "movable07"],
      },
      {
        id: "drop08",
        cat: "cat02",
        have: "",
        want: ["movable06", "movable07"],
      },
      {
        id: "drop09",
        cat: "cat02",
        have: "",
        want: ["movable06", "movable07"],
      },
      {
        id: "drop010",
        cat: "cat02",
        have: "",
        want: ["movable06", "movable07"],
      },
    ],
  },
  {
    id: "exchange.p01.g01",
    type: "sort",
    direction: "vertical",
    sortables: [
      "movable01",
      "movable02",
      "movable03",
      "movable04",
      "movable05",
    ],
  },
  {
    id: "exchange.p02.g01",
    type: "sort",
    direction: "vertical",
    sortables: [
      "movable01",
      "movable02",
      "movable03",
      "movable04",
      "movable07",
      "movable08",
    ],
  },
  {
    id: "exchange.p03.g01",
    type: "dnd",
    draggables: [
      {
        id: "movable01",
      },
      {
        id: "movable02",
      },
      {
        id: "movable03",
      },
      {
        id: "movable05",
      },
      {
        id: "movable07",
      },
      {
        id: "movable09",
      },
    ],
    droppables: [
      {
        id: "drop1",
        want: ["movable01", "movable02"],
        have: "",
        cat: "cat01",
      },
      {
        id: "drop2",
        want: ["movable01", "movable02"],
        have: "",
        cat: "cat01",
      },
      {
        id: "drop3",
        want: ["movable03"],
        have: "",
        cat: "cat02",
      },
      {
        id: "drop4",
        want: ["movable03"],
        have: "",
        cat: "cat02",
      },
      {
        id: "drop5",
        want: ["movable05", "movable07"],
        have: "",
        cat: "cat03",
      },
      {
        id: "drop6",
        want: ["movable05", "movable07"],
        have: "",
        cat: "cat03",
      },
      {
        id: "drop7",
        want: ["movable09"],
        have: "",
        cat: "cat04",
      },
      {
        id: "drop8",
        want: ["movable09"],
        have: "",
        cat: "cat04",
      },
    ],
  },
  {
    id: "exchange.p04.g01",
    type: "dnd",
    draggables: [
      {
        id: "movable01",
      },
      {
        id: "movable02",
      },
      {
        id: "movable03",
      },
      {
        id: "movable04",
      },
      {
        id: "movable05",
      },
      {
        id: "movable06",
      },
      {
        id: "movable07",
      },
      {
        id: "movable08",
      },
      {
        id: "movable09",
      },
    ],
    droppables: [
      {
        id: "drop1",
        want: ["movable01", "movable02"],
        have: "",
        cat: "cat01",
      },
      {
        id: "drop2",
        want: ["movable01", "movable02"],
        have: "",
        cat: "cat01",
      },
      {
        id: "drop3",
        want: ["movable03", "movable04"],
        have: "",
        cat: "cat02",
      },
      {
        id: "drop4",
        want: ["movable03", "movable04"],
        have: "",
        cat: "cat02",
      },
      {
        id: "drop5",
        want: ["movable05", "movable06"],
        have: "",
        cat: "cat03",
      },
      {
        id: "drop6",
        want: ["movable05", "movable06"],
        have: "",
        cat: "cat03",
      },
      {
        id: "drop7",
        want: ["movable07", "movable08"],
        have: "",
        cat: "cat04",
      },
      {
        id: "drop8",
        want: ["movable07", "movable08"],
        have: "",
        cat: "cat04",
      },
      {
        id: "drop9",
        want: ["movable09"],
        have: "",
        cat: "cat05",
      },
      {
        id: "drop10",
        want: ["movable09"],
        have: "",
        cat: "cat05",
      },
    ],
  },
]
